import axios from 'axios'
import store from '@/store'
import router from "@/router";
import {findObjectIndex} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {filters, queryBuilder} from '@moeinmdn/mixitweb-front-modules/src/plugin/class/QueryFilter'

let filtersCopy = JSON.parse(JSON.stringify(filters))

let BASE_URL = 'https://service.firecloud.shop'

export default {
    namespaced: true,
    state: {
        accounts: [],
        trash: [],
        pagination: [],
        authenticationConfig: {
            user_token: '',
            user_id: ''
        },
        ...filtersCopy,
    },
    mutations: {
        setFilters(state, filter) {
            const keys = Object.keys(state.filters)
            for (let i in keys) {
                state.filters[filter.key] = filter.value;
                return
            }
        },
    },
    actions: {
        setAuthenticationConfig({commit, state}) {
            state.authenticationConfig.user_id = store.getters['User/getUserId']
            state.authenticationConfig.user_token = localStorage.getItem('token')
        },
        authenticationConfigAsQueryString({commit, state}) {
            return `user_id=${state.authenticationConfig.user_id}&user_token=${state.authenticationConfig.user_token}`
        },
        async getAccounts({commit, state}, page = 1) {
            const query = queryBuilder(state.filters)
            await store.dispatch('FireCloudAccount/setAuthenticationConfig')
            let authenticationConfigAsQueryString = await store.dispatch('FireCloudAccount/authenticationConfigAsQueryString')
            let req = axios.get(`${BASE_URL}/api/firecloud/account?${authenticationConfigAsQueryString}&page=${page}&${query}`)
            return req
        },
        async createAccounts({commit, state}, form) {
            await store.dispatch('FireCloudAccount/setAuthenticationConfig')
            form = {
                ...form,
                ...state.authenticationConfig
            }
            let req = axios.post(`${BASE_URL}/api/firecloud/account`, form)
            return req
        },
        async updateAccounts({commit, state}, form) {
            await store.dispatch('FireCloudAccount/setAuthenticationConfig')
            form = {
                ...form,
                ...state.authenticationConfig
            }
            let req = axios.put(`${BASE_URL}/api/firecloud/account/${form.id}`, form)
            return req
        },
        async showAccount({commit, state}, form) {
            await store.dispatch('FireCloudAccount/setAuthenticationConfig')
            let authenticationConfigAsQueryString = await store.dispatch('FireCloudAccount/authenticationConfigAsQueryString')
            let req = axios.get(`${BASE_URL}/api/firecloud/account/${form.id}?${authenticationConfigAsQueryString}`)
            return req
        },
        async   destroyAccount({commit, state}, form) {
            await store.dispatch('FireCloudAccount/setAuthenticationConfig')
            let authenticationConfigAsQueryString = await store.dispatch('FireCloudAccount/authenticationConfigAsQueryString')
            let req = axios.delete(`${BASE_URL}/api/firecloud/account/${form.id}?${authenticationConfigAsQueryString}`)
            return req
        },
    },
    getters: {
        getFilters: (state) => state.filters,
    }
}